export enum EErrorType {
  FILE_EXPIRED = 'file-expired',
}

export type TErrorMessageMapper = {
  [key in EErrorType]: { message: string };
};
